import { FC } from 'react';
import { Box, BoxProps, Flex, Link, Text } from '@chakra-ui/react';
import Icon from 'ui/components/Icons/Icon';
import { CbAvatar } from '../CbAvatar';
import { CustomRecognitionStar } from 'components/CustomRecognitionStar';
export interface CbStarEntityProps extends BoxProps {
  reason: string;
  starColor?: string;
  starIcon?: string;
  starId?: string;
  starImage: string;
  starName: string;
  name: string;
  date: string;
  action: 'awarded to' | 'awarded by';
  profileId: number;
  isTruncated?: boolean;
}
export const CbStarEntity: FC<CbStarEntityProps> = ({
  action,
  reason,
  starColor,
  starIcon,
  starId,
  starImage,
  starName,
  name,
  date,
  profileId,
  isTruncated,
  ...props
}) => {
  const NameLink = () => <Link color="spyro.600" textDecoration="underline" href={`/profile/${profileId}`} _focus={{
    outline: 'none'
  }} data-sentry-element="Link" data-sentry-component="NameLink" data-sentry-source-file="CbStarEntity.tsx">
      {name}
    </Link>;
  const noOfLines = isTruncated ? 2 : 6;
  const Description = () => <Text lineHeight="22px" noOfLines={noOfLines} data-sentry-element="Text" data-sentry-component="Description" data-sentry-source-file="CbStarEntity.tsx">
      {starName} star {action} <NameLink data-sentry-element="NameLink" data-sentry-source-file="CbStarEntity.tsx" /> {'for'} {reason}
    </Text>;
  return <>
      <Flex alignItems="flex-start" {...props} data-sentry-element="Flex" data-sentry-source-file="CbStarEntity.tsx">
        {!!starImage ? <CbAvatar borderRadius={100} image={starImage} name={name} size="md" marginRight={{
        base: 4,
        lg: 6
      }} /> : <Box width={'80px'} marginLeft={-2} marginRight={3}>
            <CustomRecognitionStar iconColor={starColor as string} icon={<Icon name={starIcon} height={6} width={8} color="white" />} id={starId} />
          </Box>}
        <Box data-sentry-element="Box" data-sentry-source-file="CbStarEntity.tsx">
          <Flex alignItems="baseline" data-sentry-element="Flex" data-sentry-source-file="CbStarEntity.tsx">
            <Text fontFamily="codenext" fontWeight="bold" fontSize="lg" color="text.secondary" marginRight={2} data-sentry-element="Text" data-sentry-source-file="CbStarEntity.tsx">
              {`${starName} Star`}
            </Text>
            <Text fontSize="sm" color="text.secondary" data-sentry-element="Text" data-sentry-source-file="CbStarEntity.tsx">
              {date}
            </Text>
          </Flex>
          <Flex marginY={{
          base: 2,
          lg: 1
        }} direction={{
          base: 'column',
          md: 'row'
        }} data-sentry-element="Flex" data-sentry-source-file="CbStarEntity.tsx">
            <Description data-sentry-element="Description" data-sentry-source-file="CbStarEntity.tsx" />
          </Flex>
        </Box>
      </Flex>
    </>;
};